// Board title options and display order (rank): Chairman first, then Vice chairman, etc.
export const BOARD_TITLE_OPTIONS = [
  { label: "Chairman", value: "Chairman", order: 1 },
  { label: "Vice chairman", value: "Vice chairman", order: 2 },
  { label: "Chief Accountant", value: "Chief Accountant", order: 3 },
  { label: "Treasury", value: "Treasury", order: 4 },
  { label: "Secretary", value: "Secretary", order: 5 },
];

const TITLE_TO_ORDER = Object.fromEntries(
  BOARD_TITLE_OPTIONS.map((opt) => [opt.value, opt.order])
);

/** Get display rank for a member (by title only, so all Chairmen show first, then Vice chairman, etc.). */
export function getBoardMemberOrder(member) {
  if (member?.title) {
    return TITLE_TO_ORDER[member.title] ?? 99;
  }
  return 99;
}

/** Sort board members by rank: Chairman, Vice chairman, Chief Accountant, Treasury, Secretary. Same title = tiebreak by name. */
export function sortBoardMembersByRank(members) {
  if (!Array.isArray(members)) return [];
  return [...members].sort((a, b) => {
    const rankA = getBoardMemberOrder(a);
    const rankB = getBoardMemberOrder(b);
    if (rankA !== rankB) return rankA - rankB;
    return String(a?.name ?? "").localeCompare(String(b?.name ?? ""));
  });
}
